<template>
  <!-- prettier-ignore -->
  <div
    ref="header"
    class="row-wrapper">
    <div :class="classes">
      <div class="row-title row-cell">
        <div>
          <span class="row-title-text">&nbsp;</span></div>
      </div>

      <template v-for="(item, index) in data.contentArray">
        <div
          :key="index"
          class="content row-cell"
          :class="{'content--selected': index === selectedContentColumn}">
          <div>
            <div
              v-if="hasSubtitles"
              class="subTitle"
              v-html="getSubTitle(item)"
            />
            <div
              class="title"
              v-html="item.title"
            />
          </div>

          <div
            v-if="item.productLink"
            class="productLink">
            <a
              class="productLink-link"
              :href="getUrl(item.productLink)">
              <ovp-icon
                class="productLink-icon"
                art="solid"
                name="arrow-right-long"
              />
              <span v-text="$t('benefits.widget.productLinkText')"/>
            </a>
          </div>
        </div>
      </template>

    </div>
  </div>
</template>
<script>
import TableScrollMixin from '@/mixins/TableScroll'

export default {
  name: 'TableHeader',

  mixins: [TableScrollMixin],

  props: {
    data: {
      type: Object,
      required: true,
    },

    selectedContentColumn: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    this.tableElement = this.$refs.header
    this.attachEventListeners()
  },
  beforeDestroy() {
    this.removeEventListeners()
  },
  computed: {
    classes() {
      const numberOfColumns = this.data.contentArray.length
      return {
        row: true,
        'row-has-two-columns': numberOfColumns === 2,
        'row-has-three-columns': numberOfColumns === 3,
      }
    },
    hasSubtitles() {
      return this.data.contentArray.some(item => !!item.subTitle)
    },
  },
  methods: {
    getUrl(productLink) {
      return `${process.env.VUE_APP_SANITAS_PATH}${productLink}`
    },
    getSubTitle(item) {
      return item.subTitle ? item.subTitle : '&nbsp;'
    },
  },
}
</script>

<style name="mobile" scoped>
.row {
  &-wrapper {
    display: inline-block;
    width: 100%;
    border-bottom: 1px solid var(--c-dark-gray);

    .subTitle {
      margin-bottom: 8px;
    }

    .title {
      font-size: 20px;
      line-height: 24px;
      color: var(--c-black);
      font-weight: bold;
    }

    .productLink {
      margin-top: 8px;

      &-icon {
        margin-right: 8px;
      }
    }
  }

  display: inline-grid;
  min-width: 100%;
  min-height: 50px;
  background-color: var(--c-white);
  grid-template-columns: minmax(220px, 1fr);

  &-has-two-columns {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }

  &-has-three-columns {
    grid-template-columns: repeat(3, minmax(220px, 1fr));
  }

  &-cell {
    padding: 16px 16px 8px;
  }

  &-title {
    display: none;
    font-size: 14px;
    line-height: 18px;
    background-color: var(--c-warm-gray);

    &-icon {
      font-size: 20px;
      width: 20px;
    }

    &-text {
      margin-left: 8px;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &--selected {
      background-color: #e0efeb;
    }
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .row {
    grid-template-columns: 220px minmax(220px, 1fr);

    &-has-two-columns {
      grid-template-columns: 220px repeat(2, minmax(220px, 1fr));
    }

    &-has-three-columns {
      grid-template-columns: 220px repeat(3, minmax(220px, 1fr));
    }

    &-title {
      display: block;
      grid-column: unset;
      background-color: var(--c-white);
      margin-top: 8px;
      margin-bottom: 8px;
    }

    .content {
    }
  }
}
</style>
